export default __webpack_public_path__ + "static/media/delievers17.67af5258.jpeg";